import React from 'react';
import styled from 'styled-components';
import { colors, Heading } from '../ui-components';

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and it's
 * children. The reason for a Rich heading component, is to ensure that ALL headings
 * displayed in blog rich text should use the "Lato" font
 *
 * @function
 * @param {object} node rich-text node
 * @param {element} children collection of child rich-text nodes
 */
const RichHeading = (node, children) => {
  const headingLevel = parseInt(node.nodeType.substr(node.nodeType.length - 1));
  return <HeadingLato level={headingLevel}>{(typeof children[0] === 'string' || children[0] instanceof String) && children.length === 1 ? children[0] : children }</HeadingLato>;
};

const HeadingLato = styled(props => <Heading {...props} />)`
  ${({ level }) => {
    switch (level) {
      case 2:
        return 'font-size: 24px; line-height: 36px; margin-top: 40px; margin-bottom: 16px;';
      case 3:
        return 'font-family: "Lato", sans-serif; font-weight: bold; font-size: 18px; line-height: 32px; margin-top: 40px; margin-bottom: 16px; text-transform: uppercase;';
      case 4:
        return `font-family: "Lato", sans-serif; font-weight: bold; font-size: 16px; line-height: 32px; margin-top: 40px; margin-bottom: 20px; color: ${colors.gray1};`;
      case 5:
        return `font-family: "Lato", sans-serif; font-weight: bold; font-size: 16px; line-height: 32px; margin-bottom: 8px; font-style: italic; color: ${colors.gray1};`;
      case 6:
        return `font-size: 16px; line-height: 26px; margin-bottom: 8px; color: ${colors.gray1}; text-transform: capitalize;`;
      default:
        return '';
    }
  }}
`;
export default RichHeading;
